import { render, staticRenderFns } from "./GraffidiTestPage.vue?vue&type=template&id=461bae98"
import script from "./GraffidiTestPage.vue?vue&type=script&lang=js"
export * from "./GraffidiTestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports